export enum MyProfileRoutes {
	MY_PROFILE = 'my-profile',
	NAME = 'name',
	PHONE = 'phone',
}

// Email link, passkeys and password are managed on the identity server.
export const SIGN_IN_METHODS_URL = `${
	import.meta.env.VITE_OIDC_AUTHORITY
}/Account/Manage/SignInMethods?returnUrl=${encodeURIComponent(
	`${import.meta.env.VITE_WEBSITE_BASE_URL}/${MyProfileRoutes.MY_PROFILE}`,
)}`;

export const BREADCRUMBS_ITEMS = [
	{
		label: 'Home',
		route: '/',
	},
	{
		label: 'My S8 Profile',
		route: null,
	},
];

export const MyProfileItems: Record<MyProfileRoutes, string> = {
	[MyProfileRoutes.MY_PROFILE]: 'My S8 Profile',
	[MyProfileRoutes.NAME]: 'Name',
	[MyProfileRoutes.PHONE]: 'Phone',
};
